export class QaqcWorkOrderReq {
    plantId?: number;
    isActive?: boolean;
}

export class QaqcLotReq {
    plantId?: number;
    isActive?: boolean;
}

export class CreateQaqcFibreAnalysisReq {
    workOrderNo: string;
    lotNumber?: string;
    operation: string;
    prevOperation: string;
    productId: string;
    quality: string;
    meanLength?: number;
    shortestFiber?: number;
    longestFiber?: number;
    shortFiberPercent?: number;
    slub?: string;
    quantity: number;
    testType?: string;
    analysisType?: string;
    remarks?: string;
}

export class CreateQaqcFibreLabAnalysisReq {
    workOrderNo: string;
    lotNumber?: string;
    operation: string;
    prevOperation: string;
    productId: string;
    quality: string;
    oilTest?: number;
    oilTestRemarks?: string;
    sericinTest?: number;
    sericinTestRemarks?: string;
    acidityTest?: number;
    acidityTestRemarks?: string;
    ppContent?: number;
    ppContentRemarks?: string;
    moistureContent?: number;
    moistureContentRemarks?: string;
    quantity: number;
    testType?: string;
    analysisType?: string;
    remarks?: string;
}

export class UpdateQaqcFibreAnalysisReq {
    id: number;
    workOrderNo: string;
    lotNumber?: string;
    operation: string;
    prevOperation: string;
    productId: string;
    quality: string;
    meanLength?: number;
    shortestFiber?: number;
    longestFiber?: number;
    shortFiberPercent?: number;
    slub?: string;
    quantity: number;
    testType?: string;
    analysisType?: string;
    remarks?: string;
}

export class UpdateQaqcFibreLabAnalysisReq {
    id: number;
    workOrderNo: string;
    lotNumber?: string;
    operation: string;
    prevOperation: string;
    productId: string;
    quality: string;
    oilTest?: number;
    oilTestRemarks?: string;
    sericinTest?: number;
    sericinTestRemarks?: string;
    acidityTest?: number;
    acidityTestRemarks?: string;
    ppContent?: number;
    ppContentRemarks?: string;
    moistureContent?: number;
    moistureContentRemarks?: string;
    quantity: number;
    testType?: string;
    analysisType?: string;
    remarks?: string;
}

export class QaqcApprovalReq {
    id: number;
    testType: string;
    analysisType: string;
}

export class QaqcApprovalStatusReq {
    workOrderNo?: string;
    lotNumber?: string;
}
